/**
 * Agence'O - main-nav
 * @author Guillaume Bouillon (Agence'O)
 * @created 29/04/2019
 */

(function ($) {

  $(document).on('click', '.main-nav__trigger', (e) => {
    e.preventDefault();
    let is_open = !JSON.parse($(e.currentTarget).attr('aria-expanded'));

    $('.main-nav').toggleClass('is-open');
    $(e.currentTarget).attr('aria-expanded', is_open);
  });

  $(document).on('mouseover', '.main-nav__item', (e) => {
    if ($(window).width() > 960) {
      e.preventDefault();
      let $current = $(e.currentTarget);

      $('.main-nav__item').removeClass('is-open');
      $current.addClass('is-open');
    }
  });

  $(document).on('mouseleave', '.main-nav__item', (e) => {
    if ($(window).width() > 960) {
      e.preventDefault();
      $('.main-nav__item').removeClass('is-open');
    }
  });


  $(document).on('click', '.main-nav__item', (e) => {

    let $current = $(e.currentTarget);
    let currentLink = $current.find('.main-nav__link').html();



    /*
    if( currentLink == 'Dossiers' ) {

        $current.find('.main-nav__link').attr("href", "javacript:void(null);");
        $current.addClass('cursor-pointer');
    }*/

    if ($(window).width() < 960) {


      /*let $current = $(e.currentTarget);
      let currentLink = $current.find('.main-nav__link').html();*/

      if( currentLink == 'Dossiers' ) {
          //e.preventDefault();

          $('.main-nav__item').removeClass('is-open');
          //$current.toggleClass('is-open');
          $current.find('.main-nav__subwrap').slideToggle();
      }
    }
  });

}(jQuery));
